module.exports = __webpack_public_path__ + "media/images/pic/cold-cuts-da39c297788d5d4147559d9d8f9dfbb3.jpg";